import { cloneDeep, isEqual, isEmpty, filter, dropWhile, uniqWith, unionWith, findIndex, orderBy, groupBy, chunk } from "lodash-es";
import Constant from "@constant/index.js";

const EventPublisher = function () {

    this.eventCallbackDictionary = {};

    this.on = function (eventName, callback) {
        this.eventCallbackDictionary[eventName] = callback;
    }

    this.broadcast = function (eventName, data) {
        for (let i in this.eventCallbackDictionary) {
            if (i == eventName && this.eventCallbackDictionary[eventName]) {
                this.eventCallbackDictionary[eventName](data);
                //this.eventCallbackDictionary[eventName] = null;
            }
        }
    }
}

const $cookie = {
    removeCookie(name) {
        this.setCookie(name, "", new Date(0));
    },
    getCookie(name) {
        let cookie = document.cookie;
        let cookieName = encodeURIComponent(name) + "=",
            cookieStart = cookie.indexOf(cookieName),
            cookieValue = null;
        if (cookieStart > -1) {
            let cookieEnd = cookie.indexOf(';', cookieStart);
            if (cookieEnd == -1) {
                cookieEnd = cookie.length;
            }
            cookieValue = decodeURIComponent(cookie.substring(cookieStart + cookieName.length, cookieEnd));
        }
        return cookieValue;
    },
    setCookie(name, value, expires) {
        let cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        if (expires instanceof Date) {
            cookieText += "; expires=" + expires.toGMTString();
        } else {
            cookieText += "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        }
        document.cookie = cookieText + ";path=/;domain=" + document.domain;
    }
}

const $idSeed = {
    id: 100000,
    newId: () => {
        return $idSeed.id++;
    }
}

const $date = {
    date: function (val) {
        if (!val) { return ""; }
        //兼容Safari 日期格式 
        if (typeof val == "string") {
            val = val.replace(/-/g, "/");
        }
        if (new Date(val) == "Invalid Date") {
            return "<#非法的时间格式#>";
        }
        let d = new Date(val);
        let m = d.getMonth() + 1;
        m = m >= 10 ? m : "0" + m;
        let day = d.getDate();
        day = d.getDate() >= 10 ? d.getDate() : "0" + d.getDate();
        return d.getFullYear() + "-" + m + "-" + day;
    },
    time: function (val) {
        if (!val) { return ""; }
        if (new Date(val) == "Invalid Date") {
            return "非法的时间格式";
        }
        let d = new Date(val);
        let h = d.getHours() >= 10 ? d.getHours() : "0" + d.getHours();
        let m = d.getMinutes() >= 10 ? d.getMinutes() : "0" + d.getMinutes();
        let s = d.getSeconds() >= 10 ? d.getSeconds() : "0" + d.getSeconds();
        return h + ":" + m + ":" + s;
    },
    dateTime: function (val) {
        if (!val) {
            return "";
        }
        //兼容Safari 日期格式 
        if (typeof val == "string") {
            val = val.replace(/-/g, "/");
        }

        if (new Date(val) == "Invalid Date") {
            return "<#非法的时间格式#>";
        }
        return this.date(val) + " " + this.time(val);
    },
    compareData(one, two) {
        if (!one || !two) {
            throw new Error("非法的时间格式");
        }
        //兼容Safari 日期格式 
        if (typeof one == "string") {
            one = one.replace(/-/g, "/");
        }
        if (typeof two == "string") {
            two = two.replace(/-/g, "/");
        }
        if (new Date(one) == "Invalid Date" || new Date(two) == "Invalid Date") {
            throw new Error("非法的时间格式");
        } else {
            return new Date(one).getTime() > new Date(two).getTime() ? true : false;
        }
    },
    equalTime(start, end) {
        if (!start || !end) {
            throw new Error("非法的时间格式");
        }
        //兼容Safari 日期格式 
        if (typeof start == "string") {
            start = start.replace(/-/g, "/");
        }
        if (typeof end == "string") {
            end = end.replace(/-/g, "/");
        }
        if (new Date(start) == "Invalid Date" || new Date(end) == "Invalid Date") {
            return "非法的时间格式";
        }
        let _start = this.dateTime(start);
        let _end = this.dateTime(end);
        if (_start == _end) {
            return true;
        }
        return false;
    }
}

const $obj = {
    clone(source) {
        if (!source) {
            return null;
        }
        return cloneDeep(source);
    },
    isEqual(source, target) {
        return isEqual(source, target);
    },
    assign(source, target) {
        let cloneSource = this.clone(source);
        return cloneSource && Object.assign(cloneSource, target);
    },
    isEmpty(obj) {
        return isEmpty(obj);
    }
}

const $array = {
    isArray(arr) {
        return arr instanceof Array;
    },
    isNullArray(arr) {
        if (arr instanceof Array && arr.length != 0) {
            return false;
        }
        return true;
    },
    filter(arr, condition) {
        return filter(arr, condition);
    },
    removeItem(arr, condition) {
        return dropWhile(arr, condition);
    },
    uniq(arr) {
        return uniqWith(arr, isEqual);
    },
    union(arr1, arr2) {
        return unionWith(arr1, arr2, isEqual);
    },
    findIndex(arr, condition) {
        return findIndex(arr, condition);
    },
    sort(arr, field, desc = true) {
        let descStr = desc ? 'asc' : 'desc';
        if (isEmpty(arr)) {
            return [];
        }
        let temp = arr[0][field];
        let tmpSortKey = "__sort__" + field;

        arr.forEach(x => {
            if (!isNaN(temp)) {
                x[tmpSortKey] = x[field] / 1;
            }
            else if (new Date(temp) != 'Invalid Date') {
                x[tmpSortKey] = new Date(x[field]).getTime();
            } else {
                x[tmpSortKey] = x[field];
            }
        });


        return orderBy(arr, [tmpSortKey], [descStr]);
    },
    groupByField(arr, field) {
        return groupBy(arr, field);
    },
    groupBySize(arr, size) {
        return chunk(arr, size);
    }
}

const $util = {
    isPC() {
	    let ua = window.navigator?.userAgent.toLowerCase();
        if(ua.indexOf('openharmony') >-1) {
            return false;
        }
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            return false;
        } else if (/(Android)/i.test(navigator.userAgent)) {
            return false;
        } else {
            return true;
        };
    },
    getGroupNameByType(obj, type) {
        let res = "";
        for (let i in obj) {
            if (type == obj[i]["TYPE"]) {
                res = obj[i]["NAME"];
            }
        }
        return res;
    },
    getShopId() {
        let url = window.location.href.toLocaleLowerCase();
        if (url.indexOf('buy.lenovo.com.cn') != -1 || url.indexOf('buy.lenovouat.com') != -1) {
            return 1;
        }
        if (url.indexOf('lenovovip.com.cn') != -1 || url.indexOf('vip.lenovouat.com') != -1) {
            return 3;
        }
        if (url.indexOf('lecoo.') != -1 || url.indexOf('lecoo.lenovouat') != -1) {
            return 18;
        }
        return 1;
    },
    isProductionEnv() {
        let url = window.location.href.toLocaleLowerCase();
        if (url.indexOf('lenovouat.com') == -1) {
            return true;
        } else {
            return false;
        }
    },
    getGroup(itemType, data, itemId) {
        let group = null;
        let res = [];
        data.vendors.forEach(item => {
            item.sorted.forEach(g => {
                if (itemType == g.itemType) {
                    res.push(g.item);
                }
            })
        });

        res.forEach(x => {
            if (itemType != Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
                if (x.itemId == itemId) {
                    group = x;
                }
            } else {
                let tmp = x.skus.filter(x => {
                    return x.itemId == itemId;
                })
                // 如果是带选件的满减，主品放在 optItems里面
                if (tmp.length == 0) {
                    tmp = x.optItems.filter(x => {
                        return x.itemId == itemId;
                    })
                }
                if (tmp.length > 0) {
                    group = x;
                }
            }
        })
        return group;
    },
    getGroupByIdAndItemId(id, itemId, data, itemType) {
        let res = null;
        let group = this.getGroup(itemType, data, itemId);
        if (!group) {
            return null;
        }
        //选件 & 套餐 & 单品
        if (itemType == Constant.GROUP_TYPE.OPTION.TYPE || itemType == Constant.GROUP_TYPE.PACKAGE.TYPE || itemType == Constant.GROUP_TYPE.SINGLE.TYPE) {
            res = group;
        }
        //满减
        if (itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
            group.skus.forEach(x => {
                if (x.itemId == itemId) {
                    res = x;
                    res._groupMsg = group.stip
                }
            })
            // 如果是带选件的满减，主品放在 optItems里面
            if (!res) {
                group.optItems.forEach(x => {
                    if (x.itemId == itemId) {
                        res = x;
                        res._groupMsg = group.stip
                    }
                })
            }
        }
        return res;
    },
    getMainSkuByIdAndItemId(id, itemId, data, itemType) {
        let res = null;
        let group = this.getGroup(itemType, data, itemId);
        if (!group) {
            return { mainSku: null, group: null };
        }
        //选件 & 套餐
        if (itemType == Constant.GROUP_TYPE.OPTION.TYPE || itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            res = group.skus;
        }
        //单品
        if (itemType == Constant.GROUP_TYPE.SINGLE.TYPE) {
            res = group;
        }
        //满减
        if (itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
            group.skus.forEach(x => {
                if (x.itemId == itemId) {
                    res = x;
                }
            })
            // 如果是带选件的满减，主品放在 optItems里面
            if (!res) {
                group.optItems.forEach(x => {
                    if (x.itemId == itemId) {
                        res = x;
                    }
                })
            }
        }
        return { mainSku: res, group: group };
    },
    getAllItemIds(groups, isChecked) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (isChecked) {
                    if (sku._isChecked) {
                        res.push(sku._itemId);
                    }
                } else {
                    res.push(sku._itemId);
                }
            })
        })
        return res;
    },
    getAllItems(groups, isChecked) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (isChecked) {
                    if (sku._isChecked) {
                        res.push(sku);
                    }
                } else {
                    res.push(sku);
                }
            })
        })
        return res;
    },
    getAllPackageItems(groups) {
        let res = [];
        groups.forEach(x => {
            if (x._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && x._isChecked) {
                res.push(x);
            }
        })
        return res;
    },
    getAllItemsNotPackcage(groups, isChecked) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (isChecked) {
                    if (sku._isChecked && sku._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE) {
                        res.push(sku);
                    }
                } else {
                    res.push(sku);
                }
            })
        })
        return res;
    },
    getPurchaseEnabledMainSkus(groups) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (!sku._invalid && sku._purchaseEnable) {
                    res.push({ mainSku: sku, itemId: sku._itemId, goodscode: sku._id, categorycode: sku._data.cid, facode: sku._data.faid });
                }
            })
        })
        return res;
    },
    getInvalidItems(groups) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (sku._invalid) {
                    res.push(sku);
                }
            })
        })
        return res;
    },
    getInvalidItemIds(groups) {
        let res = [];
        this.getInvalidItems(groups).forEach(sku => {
            res.push(sku._itemId);
        })
        return res;
    },
    setAllMainSkuStatus(groups, data) {
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                let _item = this.getGroupByIdAndItemId(sku._id, sku._itemId, data, sku._parent._itemType);
                if (_item && !sku._invalid) {
                    sku._isChecked = _item.check == 0 ? false : true;
                }
            })
        })
    },
    setAllPackageStatus(groups, data) {
        groups.forEach(gop => {
            if (gop._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
                let _item = this.getGroupByItemId(gop._itemId, data.vendors);
                if (_item && !gop._invalid) {
                    gop._isChecked = _item.check == 0 ? false : true;
                }
            }
        });
    },
    getGroupByItemId(itemId, data) {
        let res = null;
        data.forEach(item => {
            item.sorted.forEach(g => {
                if (g.itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && itemId == g.item.itemId) {
                    res = g.item;
                }
            })
        });
        return res;
    },
    getMainSkuHasPromotion(mainSku) {
        let count = 0;
        /*if(mainSku._booking && mainSku._booking._leftTime){
            count++;
        }
        if(mainSku._kill && mainSku._kill._leftTime){
            count++;
        }
        if(mainSku._subscribe && mainSku._subscribe._leftTime){
            count++;
        }
        if(mainSku._subscribeSnap && mainSku._subscribeSnap._leftTime){
            count++;
        }*/
        if (mainSku._kill && mainSku._kill._type && mainSku._kill._type == Constant.PROMOTION_TYPE.KILL.TYPE) {
            if (mainSku._kill._startTime && mainSku._kill._endTime) {
                const nowDate = new Date();
                let _currentTime = nowDate.getTime() + _engine._timeDiff;
                if ($date.compareData(_currentTime, mainSku._kill._startTime) && $date.compareData(mainSku._kill._endTime, _currentTime)) {
                    count++;
                }
            }
        }
        if (mainSku._subscribeSnap) {
            if (mainSku._subscribeSnap._startTime && mainSku._subscribeSnap._endTime) {
                const nowDate = new Date();
                let _currentTime = nowDate.getTime() + _engine._timeDiff;
                if ($date.compareData(_currentTime, mainSku._subscribeSnap._startTime) && $date.compareData(mainSku._subscribeSnap._endTime, _currentTime)) {
                    count++;
                }
            }
        }
        return count > 0 ? true : false;
    },
    doLoginAction() {
        return new Promise((resolve, reject) => {
            // if(window.location.href.indexOf("localhost") == -1){
            if (passport && !passport.isLogin()) {
                passport.show();
                reject({ msg: Constant.MSG.NOT_LOGIN });
            } else {
                resolve();
            }
            // }

        })
    },
    countDown: {
        joinStr(val) {
            return val < 10 ? "0" + val : val;
        },
        doCountDown(startTime, endTime) {
            if (!startTime || !endTime) {
                throw new Error("非法的时间格式");
            }
            //兼容Safari 日期格式 
            if (typeof startTime == "string") {
                startTime = startTime.replace(/-/g, "/");
            }
            if (typeof endTime == "string") {
                endTime = endTime.replace(/-/g, "/");
            }
            if (new Date(startTime) == "Invalid Date" || new Date(endTime) == "Invalid Date") {
                return "非法的时间格式";
            }
            let start = new Date(startTime);
            let end = new Date(endTime);
            let leftTime = parseInt((end.getTime() - start.getTime()) / 1000);
            let day = parseInt(leftTime / (24 * 60 * 60));
            let hour = parseInt(leftTime / (60 * 60) % 24);
            let minute = parseInt(leftTime / 60 % 60);
            let second = parseInt(leftTime % 60);
            day = day != 0 ? day + "天 " : "";
            return day + this.joinStr(hour) + ":" + this.joinStr(minute) + ":" + this.joinStr(second);
        },
    },
    getCheckoutUrl(buyOther) {
        let _param = "";
        if (buyOther && buyOther == true) {
            _param = "&buyOther=true";
        }
        //生产环境url
        if (this.isProductionEnv()) {
            if (window._shopId == 1) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buy.lenovo.com.cn/checkout/lenovopc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuy.lenovo.com.cn/checkout/lenovo.html?buytype=0&nc=1' + _param;
                }
            } if (window._shopId == 3) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buy.lenovovip.com.cn/checkout/epppc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuy.lenovovip.com.cn/checkout/epp.html?buytype=0&nc=1' + _param;
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buy.lecoo.com/checkout/lecoopc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuy.lecoo.com/checkout/lecoo.html?buytype=0&nc=1' + _param;
                }
            }
        } else {
            if (window._shopId == 1) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buy.lenovouat.com/checkout/lenovopc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuy.lenovouat.com/checkout/lenovo.html?buytype=0&nc=1' + _param;
                }
            } if (window._shopId == 3) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buy.vip.lenovouat.com/checkout/epppc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuy.vip.lenovouat.com/checkout/epp.html?buytype=0&nc=1' + _param;
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://buylecoo.lenovouat.com/checkout/lecoopc.html?buytype=0&nc=1' + _param;
                } else {
                    return 'https://mbuylecoo.lenovouat.com/checkout/lecoo.html?buytype=0&nc=1' + _param;
                }
            }
        }
    },
    getHomeUrl() {
        // biz
        if(document.domain.indexOf('biz') > -1) {
            const device = window._terminal == Constant.TERMINAL.PC ? 'pc' : 'wap';
            const env = this.isProductionEnv() ? 'prod' : 'uat';
            const HOME_URL = {
                prod: {
                    pc: 'https://biz.lenovo.com.cn/',
                    wap: 'https://mbiz.lenovo.com.cn/'
                },
                uat: {
                    pc: 'https://biz.lenovouat.com/',
                    wap: 'https://mbiz.lenovouat.com/'
                }
            }
            return HOME_URL?.[env]?.[device] || '';
        }
        const homeUrlPCUat = $util.isBSite() ? 'https://b.lenovouat.com/' : 'https://shop.lenovouat.com/'
        const homeUrlWapUat = $util.isBMSite() ? 'https://bm.lenovouat.com/' : 'https://m.lenovouat.com/'

        const homeUrlPCProd = $util.isBSite() ? 'https://b.lenovo.com.cn/' : 'https://shop.lenovo.com.cn/'
        const homeUrlWapProd = $util.isBMSite() ? 'https://bm.lenovo.com.cn/' : 'https://m.lenovo.com.cn/'
        //生产环境url
        if (this.isProductionEnv()) {
            if (window._shopId == 1) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return homeUrlPCProd;
                } else {
                    return homeUrlWapProd;
                }
            } else if (window._shopId == 3) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://www.lenovovip.com.cn';
                } else {
                    return 'https://m.lenovovip.com.cn/';
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://www.lecoo.com/';
                } else {
                    return 'https://wap.lecoo.com/';
                }
            }
        } else {
            if (window._shopId == 1) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return homeUrlPCUat;
                } else {
                    return homeUrlWapUat;
                }
            } else if (window._shopId == 3) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://www.vip.lenovouat.com';
                } else {
                    return 'https://m.vip.lenovouat.com/';
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return 'https://lecoo.lenovouat.com/';
                } else {
                    return 'https://mlecoo.lenovouat.com/';
                }
            }
        }

    },
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return unescape(r[2]); return ''; //返回参数值
    },
    // 是否为b域名
    isBSite() {
        return document.domain.indexOf('b.') > -1;
    },
    // 是否为bm域名
    isBMSite() {
        return document.domain.indexOf('bm.') > -1;
    },
    getLoginUrl(ru = '') {
        //生产环境url 1-官网 18-来酷
        const sitePrefixUat  = ($util.isBSite() || $util.isBMSite()) ? 'https://reg.lenovouat.com/user_auth/tob/#/login' : 'https://reg.lenovouat.com/user_auth/toc/#/login';
        const sitePrefixProd = ($util.isBSite() || $util.isBMSite()) ? 'https://reg.lenovo.com.cn/user_auth/tob/#/login' : 'https://reg.lenovo.com.cn/user_auth/toc/#/login';
        if(this.isProductionEnv()){
            if(window._shopId == 1){
                if(window._terminal == Constant.TERMINAL.PC){
                    return `${sitePrefixProd}?ticket=${$util.getUrlParam('ticket') || 'e40e7004-4c8a-4963-8564-31271a8337d8'}&ru=${ru}`;
                } else {
                    return `${sitePrefixProd}?ticket=${$util.getUrlParam('ticket') || 'b044d754-bda2-4f56-9fea-dcf3aecfe782'}&iswap=0&ru=${ru}`;
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return `https://reg.lecoo.com/auth/v1/login?ticket=${$util.getUrlParam('ticket') || 'e87576d9-9040-4849-ba1d-290415ce599b'}&ru=${ru}`;
                } else {
                    return `https://reg.lecoo.com/auth/v1/login?ticket=${$util.getUrlParam('ticket') || '0e2472f5-f399-4144-ac8c-f3e9af73511b'}&ru=${ru}`;
                }
            }
        } else {
            if (window._shopId == 1) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return `${sitePrefixUat}?ticket=${$util.getUrlParam('ticket') || 'e40e7004-4c8a-4963-8564-31271a8337d8'}&ru=${ru}`;
                } else {
                    return `${sitePrefixUat}?ticket=${$util.getUrlParam('ticket') || 'b044d754-bda2-4f56-9fea-dcf3aecfe782'}&iswap=0&ru=${ru}`;
                }
            } else if (window._shopId == 18) {
                if (window._terminal == Constant.TERMINAL.PC) {
                    return `https://reglecoo.lenovouat.com/auth/v1/login?ticket=${$util.getUrlParam('ticket') || 'e87576d9-9040-4849-ba1d-290415ce599b'}&ru=${ru}`;
                } else {
                    return `https://reglecoo.lenovouat.com/auth/v1/login?ticket=${$util.getUrlParam('ticket') || '0e2472f5-f399-4144-ac8c-f3e9af73511b'}&ru=${ru}`;
                }
            }
        }

    },
    getMyMessagetUrl() {
        //生产环境url
        if (this.isProductionEnv()) {
            return 'https://i.lenovo.com.cn/internal/msg/list.jhtml?sts=b044d754-bda2-4f56-9fea-dcf3aecfe782';
        } else {
            return 'https://i.lenovouat.com/internal/msg/list.jhtml?sts=b044d754-bda2-4f56-9fea-dcf3aecfe782';
        }
    },
    getAllFakeCheckedItemsNotPackcage(groups, isChecked) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (isChecked) {
                    if (sku._isChecked_fake && sku._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE) {
                        res.push(sku);
                    }
                } else {
                    res.push(sku);
                }
            })
        })
        //选中的普通商品
        let _skusNormal = this.getAllItemsNotPackcage(groups, isChecked);
        return res.concat(_skusNormal);
    },
    getAllFakeCheckedItems(groups, isChecked) {
        let res = [];
        groups.forEach(x => {
            x._mainSkus.forEach(sku => {
                if (isChecked) {
                    if (sku._isChecked_fake || x._isChecked_fake) {
                        res.push(sku);
                    }
                } else {
                    res.push(sku);
                }
            })
        })
        //选中的所有商品
        let _skusNormal = this.getAllItems(groups, isChecked);
        return res.concat(_skusNormal);
    },
    getAllFakeCheckedPackageItems(groups) {
        let res = [];
        groups.forEach(x => {
            if (x._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE && x._isChecked_fake) {
                res.push(x);
            }
        })
        // 选中的普通套餐
        let _groupsNormal = this.getAllPackageItems(groups);
        return res.concat(_groupsNormal);
    },
    toggleBodyScroller(tag) {
        if (tag) {
            $("body").addClass("bodyScrollerHide");
        } else {
            $("body").removeClass("bodyScrollerHide");
        }
    },
    // 用于动态渲染有条件的html，避免项目中割裂的html拼接。
    renderHTML({ decision = false, html = '' }) {
        let _decision = decision;
        if (typeof decision === 'function') {
            _decision = decision();
        }
        if (_decision) {
            return html;
        } else {
            return '';
        }
    }
}

var rotateLeft = function (lValue, iShiftBits) {
    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
}

var addUnsigned = function (lX, lY) {
    var lX4, lY4, lX8, lY8, lResult;
    lX8 = (lX & 0x80000000);
    lY8 = (lY & 0x80000000);
    lX4 = (lX & 0x40000000);
    lY4 = (lY & 0x40000000);
    lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
    if (lX4 & lY4) return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
    if (lX4 | lY4) {
        if (lResult & 0x40000000) return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
        else return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
    } else {
        return (lResult ^ lX8 ^ lY8);
    }
}

var F = function (x, y, z) {
    return (x & y) | ((~x) & z);
}

var G = function (x, y, z) {
    return (x & z) | (y & (~z));
}

var H = function (x, y, z) {
    return (x ^ y ^ z);
}

var I = function (x, y, z) {
    return (y ^ (x | (~z)));
}

var FF = function (a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(F(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
};

var GG = function (a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(G(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
};

var HH = function (a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(H(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
};

var II = function (a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(I(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
};

var convertToWordArray = function (string) {
    var lWordCount;
    var lMessageLength = string.length;
    var lNumberOfWordsTempOne = lMessageLength + 8;
    var lNumberOfWordsTempTwo = (lNumberOfWordsTempOne - (lNumberOfWordsTempOne % 64)) / 64;
    var lNumberOfWords = (lNumberOfWordsTempTwo + 1) * 16;
    var lWordArray = Array(lNumberOfWords - 1);
    var lBytePosition = 0;
    var lByteCount = 0;
    while (lByteCount < lMessageLength) {
        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
        lBytePosition = (lByteCount % 4) * 8;
        lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
        lByteCount++;
    }
    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
    return lWordArray;
};

var wordToHex = function (lValue) {
    var WordToHexValue = "", WordToHexValueTemp = "", lByte, lCount;
    for (lCount = 0; lCount <= 3; lCount++) {
        lByte = (lValue >>> (lCount * 8)) & 255;
        WordToHexValueTemp = "0" + lByte.toString(16);
        WordToHexValue = WordToHexValue + WordToHexValueTemp.substr(WordToHexValueTemp.length - 2, 2);
    }
    return WordToHexValue;
};

var uTF8Encode = function (string) {
    string = string.replace(/\x0d\x0a/g, "\x0a");
    var output = "";
    for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
            output += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
            output += String.fromCharCode((c >> 6) | 192);
            output += String.fromCharCode((c & 63) | 128);
        } else {
            output += String.fromCharCode((c >> 12) | 224);
            output += String.fromCharCode(((c >> 6) & 63) | 128);
            output += String.fromCharCode((c & 63) | 128);
        }
    }
    return output;
};

const $crypto = {
    md5(string) {
        var x = Array();
        var k, AA, BB, CC, DD, a, b, c, d;
        var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
        var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
        var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
        var S41 = 6, S42 = 10, S43 = 15, S44 = 21;
        string = uTF8Encode(string);
        x = convertToWordArray(string);
        a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;
        for (k = 0; k < x.length; k += 16) {
            AA = a; BB = b; CC = c; DD = d;
            a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
            d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
            c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
            b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
            a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
            d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
            c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
            b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
            a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
            d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
            c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
            b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
            a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
            d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
            c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
            b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
            a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
            d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
            c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
            b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
            a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
            d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
            c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
            b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
            a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
            d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
            c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
            b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
            a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
            d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
            c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
            b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
            a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
            d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
            c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
            b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
            a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
            d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
            c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
            b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
            a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
            d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
            c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
            b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
            a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
            d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
            c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
            b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
            a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
            d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
            c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
            b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
            a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
            d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
            c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
            b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
            a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
            d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
            c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
            b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
            a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
            d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
            c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
            b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
            a = addUnsigned(a, AA);
            b = addUnsigned(b, BB);
            c = addUnsigned(c, CC);
            d = addUnsigned(d, DD);
        }
        var tempValue = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
        return tempValue.toLowerCase();
    }
}

const $event_publisher = new EventPublisher();

// 用于生成随机id
export const guid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}


export {
    $util,
    $cookie,
    $idSeed,
    $event_publisher,
    $obj,
    $array,
    $date,
    $crypto
}

export default {
    $util,
    $cookie,
    $idSeed,
    $event_publisher,
    $obj,
    $array,
    $date,
    $crypto
}